// extracted by mini-css-extract-plugin
export default {"wrap":"SocialLoginButtons_wrap__TEhuJ"};